import { THttpService } from '@/services/HttpService';

import { TPriorityResponse } from './types';

export const getPriority = async (
  api: THttpService,
  channel: string,
  place = 'home_1',
  request_id?: string,
): Promise<TPriorityResponse[] | null> => {
  const { data } = await api.get(
    `/recommendation/priority?place=${place}&channel=${channel}&request_id=${request_id}`,
  );

  return data
    ? data.map(
        (item: TPriorityResponse) =>
          ({
            ...item,
            template: item.template.toString(),
            layout: item.layout.toString(),
          } as TPriorityResponse),
      )
    : null;
};
